export default date => {
    if (!date) return null
    
    const dateTime = new Date(date)
	return `${dateTime.getHours().toString().padStart(2, '0')}:${dateTime.getMinutes().toString().padStart(2, '0')}:${dateTime.getSeconds().toString().padStart(2, '0')}`
}